<script>
import emailjs from '@emailjs/browser'; import Swal from "sweetalert2";
export default {
  methods: {
    sendEmail() {
      emailjs.sendForm('service_o10ni4h', 'template_g8ir5ck',
        this.$refs.form, '9dXIW13fiQT0eCgk5').then(() => { location.href = "/"; }).catch((error) => { alert(error); }); Swal.fire({ icon: "success", title: "En un momento un asesor se comunicara contigo.", showConfirmButton: false, timer: 1500, });
    }
  }
};
</script>

<template>
  <div>
    <!-- CONTACT FORM START-->
    <section class="section" id="contact">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <h1 class="section-title text-center">¿Dudas? Contáctanos</h1>
            <div class="section-title-border margin-t-20"></div>
          </div>
        </div>
        <div class="row" style="margin-top: 25px">
          <div id="message"></div>

          <div class="col-lg-4-5">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1750.4953738080014!2d-106.10110334401739!3d28.659995702970907!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86ea431a4faceded%3A0x34654aee4cb10d82!2sIBS%20Consultores%20Asesores%20en%20Seguros%20%26%20Fianzas!5e0!3m2!1ses-419!2smx!4v1700089622303!5m2!1ses-419!2smx"
              width="363" height="313" style="border:0; margin-top:10px;" allowfullscreen="" loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"></iframe>
          </div>
          <div class="col-lg-4-5">
            <div class="custom-form" style="margin-top: -29px;">
              <div style="padding: 11px;">
                <p class="mt-4">
                  <span class="h5 text-center">Dirección:</span>
                  <br />
                  <span class="text-muted d-block mt-2">González Cossio 3703, Col. Granjas</span><br>
                </p>
                <p class="mt-4">
                  <span class="h5">Horarios:</span>
                  <br />
                  <span class="text-muted d-block mt-2">Lunes - Viernes <br> 08:30AM - 6:00PM</span>
                  <span class="text-muted d-block mt-2">Sábados <br> 09:00AM - 01:00PM</span>
                  <span class="text-muted d-block mt-2">Domingos <br> CERRADO</span>
                </p>
              </div>
            </div>
          </div>
          <form id="contact-form" class="con" ref="form" @submit.prevent="sendEmail">
            <div class="row naem">
              <div class="col-lg-6-form">
                <div class="form-group mt-2">
                  <input name="name" id="con_name" type="text" class="form-control" placeholder="Nombre Completo*" />
                </div>
              </div>
              <div class="col-lg-6-form">
                <div class="form-group mt-2">
                  <input name="con_email" id="email" type="email" class="form-control"
                    placeholder="Correo Electrónico*" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group mt-2">
                  <input type="text" class="form-control" id="subject" placeholder="Teléfono.." />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group mt-2">
                  <textarea name="con_message" id="comments" rows="4" class="form-control"
                    placeholder="Escribe tu mensaje..."></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-right">
                <input type="submit" id="submit" name="send" class="submitBnt btn btn-custom" value="Enviar mensaje" />
                <div id="simple-msg"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <!-- CONTACT FORM END-->

    <!--START SOCIAL-->
    <section class="cta bg-light">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <ul class="list-inline social margin-t-20">
              <li class="list-inline-item">
                <a href="https://www.facebook.com/VoySeguroMexico/" target="_blank" class="social-icon">
                  <i class="mdi mdi-facebook"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://twitter.com/VoySeguroMexico/" target="_blank" class="social-icon">
                  <i class="mdi mdi-twitter"></i>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://www.instagram.com/VoySeguroMexico/" target="_blank" class="social-icon">
                  <i class="mdi mdi-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 margin-t-30">
            <a class="margin-b-0 contact-title" href="tel:">
              <i class="pe-7s-call"></i>&nbsp;800 777 0911
            </a>
          </div>
          <div class="col-lg-3 margin-t-30">
            <a class="contact-title" href="mailto:contacto@ibsconsultores.com">
              <i class="pe-7s-mail-open"></i>&nbsp;contacto@ibsconsultores.com
            </a>
          </div>
        </div>
      </div>
    </section>
    <!--END SOCIAL-->
  </div>
</template>
<style>
@media (max-width: 414px) {

  .custom-form,
  .naem {
    margin-left: 41px
  }

  .con {
    margin-left: -114px;
    padding-left: 113px;
  }

  .col-lg-6-form {
    width: 313px;
  }
}

@media (min-width: 991px) {
  .con {
    width: 50%;
  }

}

@media (min-width: 992px) {
  .col-lg-4-5 {
    flex: 0 0 21%;
    max-width: 33.333333%;
  }

}


@media (min-width: 1199px) {
  .con {
    width: 45%;
  }

}
</style>